export function getClientDeviceType() {
	const ua = navigator.userAgent;

	if (/tablet|ipad|playbook|silk/i.test(ua)) return 'tablet';
	// iPads on iOS 13+ masquerade as desktop Safari
	if (navigator.maxTouchPoints > 1 && /macintosh/i.test(ua)) return 'tablet';
	if (/mobile|iphone|ipod|android|blackberry|opera mini|iemobile/i.test(ua))
		return 'phone';
	return 'desktop';
}
